// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Belt_List from "../../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as City$PorterinFeature from "../../../../shared/core/helpers/City.mjs";
import * as PnMHelper$PorterinFeature from "./PnMHelper.mjs";
import * as PnMStoreEn$PorterinFeature from "../store/PnMStoreEn.mjs";
import * as ExtendedAddress$PorterinFeature from "../../../fare-estimate-v1/domain/entity/ExtendedAddress.mjs";

function getFormData(output, user_city) {
  return {
          name: output.name,
          mobile: output.mobile,
          pickup: {
            landmark: output.pickup.landmark,
            location: {
              lat: output.pickup.location.lat,
              lng: output.pickup.location.lng
            },
            extended_address: {
              state: output.pickup.extended_address.state,
              city: output.pickup.extended_address.city,
              pincode: output.pickup.extended_address.pincode,
              locality: output.pickup.extended_address.locality,
              sub_locality: output.pickup.extended_address.sub_locality
            }
          },
          drop: {
            landmark: output.drop.landmark,
            location: {
              lat: output.drop.location.lat,
              lng: output.drop.location.lng
            },
            extended_address: {
              state: output.drop.extended_address.state,
              city: output.drop.extended_address.city,
              pincode: output.drop.extended_address.pincode,
              locality: output.drop.extended_address.locality,
              sub_locality: output.drop.extended_address.sub_locality
            }
          },
          geo_region_id: City$PorterinFeature.cityToGeoRegionId(Belt_Option.getWithDefault(user_city, "")),
          date: Caml_option.some(output.date)
        };
}

function clearPickup($$event, form) {
  Curry._2(form.updatePickup, (function (input, param) {
          return {
                  pickup: ExtendedAddress$PorterinFeature.initial_address(undefined),
                  drop: input.drop,
                  date: input.date,
                  name: input.name,
                  mobile: input.mobile,
                  house: input.house,
                  show_house_field: input.show_house_field
                };
        }), $$event.target.value);
}

function clearDrop($$event, form) {
  Curry._2(form.updateDrop, (function (input, param) {
          return {
                  pickup: input.pickup,
                  drop: ExtendedAddress$PorterinFeature.initial_address(undefined),
                  date: input.date,
                  name: input.name,
                  mobile: input.mobile,
                  house: input.house,
                  show_house_field: input.show_house_field
                };
        }), $$event.target.value);
}

function clearMobile($$event, form) {
  Curry._2(form.updateMobile, (function (input, param) {
          return {
                  pickup: input.pickup,
                  drop: input.drop,
                  date: input.date,
                  name: input.name,
                  mobile: "",
                  house: input.house,
                  show_house_field: input.show_house_field
                };
        }), $$event.target.value);
}

function clearDate(form) {
  Curry._2(form.updateDate, (function (input, param) {
          return {
                  pickup: input.pickup,
                  drop: input.drop,
                  date: PnMHelper$PorterinFeature.getMinDate(undefined),
                  name: input.name,
                  mobile: input.mobile,
                  house: input.house,
                  show_house_field: input.show_house_field
                };
        }), new Date());
}

function pickupLocationHandler(form, addressValue, postalAddress) {
  Curry._2(form.updatePickup, (function (input, value) {
          return {
                  pickup: PnMHelper$PorterinFeature.createAddress(value.landmark, value.location, postalAddress),
                  drop: input.drop,
                  date: input.date,
                  name: input.name,
                  mobile: input.mobile,
                  house: input.house,
                  show_house_field: input.show_house_field
                };
        }), PnMHelper$PorterinFeature.createAddress(addressValue.landmark, addressValue.location, postalAddress));
}

function dropLocationHandler(form, addressValue, postalAddress) {
  Curry._2(form.updateDrop, (function (input, value) {
          return {
                  pickup: input.pickup,
                  drop: PnMHelper$PorterinFeature.createAddress(value.landmark, value.location, postalAddress),
                  date: input.date,
                  name: input.name,
                  mobile: input.mobile,
                  house: input.house,
                  show_house_field: input.show_house_field
                };
        }), PnMHelper$PorterinFeature.createAddress(addressValue.landmark, addressValue.location, postalAddress));
}

function displayHouseSize(house_size) {
  switch (house_size) {
    case /* OneBhk */0 :
        return PnMStoreEn$PorterinFeature.oneBhkString;
    case /* TwoBhk */1 :
        return PnMStoreEn$PorterinFeature.twoBhkString;
    case /* ThreeBhk */2 :
        return PnMStoreEn$PorterinFeature.threeBhkString;
    case /* OneRk */3 :
        return PnMStoreEn$PorterinFeature.oneRKString;
    
  }
}

function displayStringToHouseSize(house_size) {
  if (house_size === PnMStoreEn$PorterinFeature.oneBhkString) {
    return /* OneBhk */0;
  } else if (house_size === PnMStoreEn$PorterinFeature.oneRKString) {
    return /* OneRk */3;
  } else if (house_size === PnMStoreEn$PorterinFeature.twoBhkString) {
    return /* TwoBhk */1;
  } else {
    return /* ThreeBhk */2;
  }
}

function getHouseSizeOptions(param) {
  return Belt_List.map(PnMStoreEn$PorterinFeature.houseSizeList, displayHouseSize);
}

function clearHouseSize($$event, form) {
  Curry._2(form.updateHouse, (function (input, param) {
          return {
                  pickup: input.pickup,
                  drop: input.drop,
                  date: input.date,
                  name: input.name,
                  mobile: input.mobile,
                  house: undefined,
                  show_house_field: input.show_house_field
                };
        }), $$event.target.value);
}

function updateHouseSize(value, form) {
  Curry._2(form.updateHouse, (function (input, value) {
          return {
                  pickup: input.pickup,
                  drop: input.drop,
                  date: input.date,
                  name: input.name,
                  mobile: input.mobile,
                  house: value,
                  show_house_field: input.show_house_field
                };
        }), displayStringToHouseSize(value));
}

export {
  getFormData ,
  clearPickup ,
  clearDrop ,
  clearMobile ,
  clearDate ,
  pickupLocationHandler ,
  dropLocationHandler ,
  displayHouseSize ,
  displayStringToHouseSize ,
  getHouseSizeOptions ,
  clearHouseSize ,
  updateHouseSize ,
}
/* City-PorterinFeature Not a pure module */
